import { render, staticRenderFns } from "./applyReturnOrderrCartManage.vue?vue&type=template&id=883c1410&scoped=true"
import script from "./applyReturnOrderrCartManage.vue?vue&type=script&lang=js"
export * from "./applyReturnOrderrCartManage.vue?vue&type=script&lang=js"
import style0 from "./applyReturnOrderrCartManage.vue?vue&type=style&index=0&id=883c1410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883c1410",
  null
  
)

export default component.exports